var map = {
	"./base": 111,
	"./base.vue": 111,
	"./birthday": 283,
	"./birthday.vue": 283,
	"./donate": 284,
	"./donate.vue": 284,
	"./phapa": 285,
	"./phapa.vue": 285,
	"./special-events": 286,
	"./special-events.vue": 286
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 736;


//////////////////
// WEBPACK FOOTER
// ./src/components/templates/products ^\.\/.*$
// module id = 736
// module chunks = 1